export const iconFontAwesomeFoodBeverageBeerMugEmpty = (
	<i className="fa-solid fa-beer-mug-empty"></i>
);
